import moment from "moment";

interface Promo {
  appPicture: string;
  appTemplate: string;
  daysAfterBirthday: number;
  description: string;
  endDate: string;
  friday: boolean;
  id: number;
  isBirthdayCampaign: boolean;
  monday: boolean;
  name: string;
  promoType: string;
  promotedCategories: any[];
  promotedCategoriesDetail: any[];
  promotedProducts: string[];
  promotedProductsDetail: { code: string; name: string }[];
  promotedSuppliers: any[];
  promotedSuppliersDetail: any[];
  rating: number;
  saturday: boolean;
  startDate: string;
  sunday: boolean;
  thursday: boolean;
  tuesday: boolean;
  validTo: string;
  value: number;
  wednesday: boolean;
}

export function getPromoTypeDescription(data: Promo) {
  switch (data.promoType) {
    case "PROMO_PRODUCT_RowDiscount_Percentage":
      return (
        "Acquistando " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto del " +
        data.value +
        "%"
      );
    case "PROMO_PRODUCT_RowDiscount_Value":
      return (
        "Acquistando " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value)
      );
    case "PROMO_PRODUCT_Row32":
      return (
        "Acquistando 3 pezzi di " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " uno &egrave; gratis "
      );
    case "PROMO_PRODUCT_AddPoint":
      return (
        "Acquistando " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        (data.value === 1
          ? " viene accreditato 1 punto bonus"
          : " vengono accreditati " + data.value + " punti bonus")
      );
    case "PROMO_PRODUCT_CheckDiscount_Percentage":
      return (
        "Acquistando " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto del " +
        data.value +
        "% sullo scontrino"
      );
    case "PROMO_PRODUCT_CheckDiscount_Value":
      return (
        "Acquistando " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value) +
        " sullo scontrino"
      );
    case "PROMO_PRODUCT_11":
      return (
        "Acquistando 2 pezzi di " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " uno &egrave; gratis"
      );
    case "PROMO_PRODUCT_MULTI":
      return (
        "Acquistando " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " i punti accreditati per il prodotto vengono moltiplicati per " +
        data.value
      );
    case "PROMO_CAT_RowDiscount_Value":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value)
      );
      case "PROMO_CAT_RowDiscount_Percentage":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto del " +
        data.value + '%'
      );
    case "PROMO_CAT_AddPoint":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " vengono accreditati " +
        data.value +
        " punti bonus"
      );
    case "PROMO_CAT_CheckDiscount_Percentage":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        (data.value === 1
          ? " viene applicato uno sconto dell' 1% sullo scontrino"
          : " viene applicato uno sconto del " +
            data.value +
            "% sullo scontrino")
      );
    case "PROMO_CAT_CheckDiscount_Value":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value) +
        " sullo scontrino"
      );
    case "PROMO_CAT_MULTI":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " i punti accreditati per il prodotto vengono moltiplicati per " +
        data.value
      );
    case "PROMO_SUP_RowDiscount_Percentage":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto del " +
        data.value +
        "%"
      );
    case "PROMO_SUP_RowDiscount_Value":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value)
      );
    case "PROMO_SUP_AddPoint":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        (data.value === 1
          ? " viene accreditato 1 punto bonus"
          : " vengono accreditati " + data.value + " punti bonus")
      );
    case "PROMO_SUP_CheckDiscount_Percentage":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto del " +
        data.value +
        "% sullo scontrino"
      );
    case "PROMO_SUP_CheckDiscount_Value":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value) +
        " sullo scontrino"
      );
    case "PROMO_SUP_MULTI":
      return (
        "Acquistando un prodotto " +
        getEntita(
          data.promotedProducts,
          data.promotedCategories,
          data.promotedSuppliers
        ) +
        " i punti accreditati per il prodotto vengono moltiplicati per " +
        data.value
      );
    default:
      return "";
  }
}

const getEntita = (
  promotedProducts: string[],
  promotedCategories: string[],
  promotedSuppliers: string[]
) => {
  let result = "";

  if (promotedProducts.length > 0) {
    return promotedProducts.join(", ");
  }

  if (promotedSuppliers.length > 0) {
    if (promotedSuppliers.length > 1) {
      result += " delle ditte " + promotedSuppliers.join(", ");
    } else {
      result += " della ditta " + promotedSuppliers[0];
    }

    if (promotedCategories.length > 0) {
      result += " e appartenente";

      if (promotedCategories.length > 1) {
        result += " alle categorie " + promotedCategories.join(", ");
      } else {
        result += " alla categoria " + promotedCategories[0];
      }
    }

    return result;
  }

  if (promotedCategories.length > 0) {
    if (promotedCategories.length === 1) {
      result = " della categoria " + promotedCategories[0];
    } else {
      result = " delle categorie " + promotedCategories.join(", ");
    }
  }

  return result;
};

const currencyFormat = (value: number) => {
  return value + " €";
};

export function getValorePromo(tipo: string, valore: number): string {
  switch (tipo) {
    case "PROMO_PRODUCT_RowDiscount_Percentage":
    case "PROMO_PRODUCT_CheckDiscount_Percentage":
    case "PROMO_PRODUCT_CheckDiscount_Value":
    case "PROMO_CAT_RowDiscount_Percentage":
    case "PROMO_CAT_CheckDiscount_Percentage":
    case "PROMO_SUP_RowDiscount_Percentage":
    case "PROMO_SUP_CheckDiscount_Percentage":
      return "vale il " + valore + "%";
    case "PROMO_PRODUCT_RowDiscount_Value":    
    case "PROMO_CAT_RowDiscount_Value":
    case "PROMO_CAT_CheckDiscount_Value":
    case "PROMO_SUP_RowDiscount_Value":
    case "PROMO_SUP_CheckDiscount_Value":
      return "vale " + currencyFormat(valore);
    case "PROMO_PRODUCT_MULTI":
    case "PROMO_CAT_MULTI":
    case "PROMO_SUP_MULTI":
      return "moltiplica per " + valore + " i tuoi punti";
    case "PROMO_PRODUCT_Row32":
      return "3x2";
    case "PROMO_PRODUCT_AddPoint":
    case "PROMO_CAT_AddPoint":
    case "PROMO_SUP_AddPoint":
      return "vale " + valore + (valore === 1 ? " punto" : " punti");
    case "PROMO_PRODUCT_11":
      return "promozione 1+1";
    default:
      return "";
  }
}
